import React from "react";
import { Col, FormGroup, Input, Label, Row } from "reactstrap";
import { Btn, P } from "../../../../../../../AbstractElements";
import { ProceedToBack, ProceedToNext } from "../../../../../../../Constants/Constants";
import { ShippingInformationProps } from "../../../../../../../Types/FormsType";
import { ShippingMethodsData } from "../../../../../../../Data/Forms&Table/Forms/FormLayout";

const ShippingMethods: React.FC<ShippingInformationProps> = ({ radioBoxValues, updateFormData, handleNextButton, handleBackButton }) => {
  const { shippingMethod } = radioBoxValues;
  return (
    <Row className="shipping-method g-3">
      {ShippingMethodsData.map((data, index) => (
        <Col sm="6" key={index}>
          <div className="card-wrapper border rounded-3 h-100 light-card">
            <FormGroup check className="radio radio-primary">
              <Input id={data.value} type="radio" name="shippingMethod" value={data.value} checked={shippingMethod === data.value} onChange={updateFormData} />
              <Label className="mb-0" htmlFor={data.value} check>{data.label}</Label>
            </FormGroup>
            <P>{data.details}</P>
          </div>
        </Col>
      ))}
      <Col xs="12" className="text-end">
        <Btn onClick={handleBackButton} color="primary" className="me-1"><i className="fa fa-truck proceed-prev" />{ProceedToBack}</Btn>
        <Btn onClick={handleNextButton} color="primary">{ProceedToNext}<i className="fa fa-truck proceed-next" /></Btn>
      </Col>
    </Row>
  );
};

export default ShippingMethods;
